export const tokens = {
  FS64FW700LH76_8B: {
    fontFamily: 'SofiaSans-Bold',
    fontSize: '64px',
    fontWeight: '700',
    lineHeight: '76.8px',
  },
  FS40FW800LH48EB: {
    fontFamily: 'SofiaSans-ExtraBold',
    fontSize: '40px',
    fontWeight: '800',
    lineHeight: '48px',
  },
  FS40FW500LH48R: {
    fontFamily: 'SofiaSans-Regular',
    fontSize: '40px',
    fontWeight: '400',
    lineHeight: '48px',
  },
  FS36FW500LH43_2B: {
    fontFamily: 'SofiaSans-Medium',
    fontSize: '36px',
    fontWeight: '500',
    lineHeight: '43.2px',
  },
  FS32FW700LH52_48B: {
    fontFamily: 'SofiaSans-Bold',
    fontSize: '32px',
    fontWeight: '700',
    lineHeight: '52.48px',
  },
  FS32FW500LH38_4M: {
    fontFamily: 'SofiaSans-Medium',
    fontSize: '32px',
    fontWeight: '500',
    lineHeight: '38.4px',
  },
  FS30FW500LH36M: {
    fontFamily: 'SofiaSans-Medium',
    fontSize: '30px',
    fontWeight: '500',
    lineHeight: '36px',
  },
  FS26FW500LH38_66M: {
    fontFamily: 'SofiaSans-Medium',
    fontSize: '26px',
    fontWeight: '500',
    lineHeight: '38.66px',
  },
  FS26FW500LH31_2M: {
    fontFamily: 'SofiaSans-Medium',
    fontSize: '26px',
    fontWeight: '500',
    lineHeight: '31.2px',
  },
  FS26FW500LH31_2Msdasd: {
    fontFamily: 'SofiaSans-Medium',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '31.2px',
  },
  FS26FW600LH31_B: {
    fontFamily: 'SofiaSans-Bold',
    fontSize: '26px',
    fontWeight: '600',
    lineHeight: '31.2px',
  },

  FS26FW400LH31_2R: {
    fontFamily: 'SofiaSans-Regular',
    fontSize: '26px',
    fontWeight: '400',
    lineHeight: '31.2px',
  },

  FS20FW700LH24B: {
    fontFamily: 'SofiaSans-Bold',
    fontSize: '20px',
    fontWeight: '700',
    lineHeight: '24px',
  },
  FS20FW500LH24SB: {
    fontFamily: 'SofiaSans-SemiBold',
    fontSize: '20px',
    fontWeight: '600',
    lineHeight: '24px',
    textTransform: 'none',
  },
  FS20FW500LH24M: {
    fontFamily: 'SofiaSans-Medium',
    fontSize: '20px',
    fontWeight: '500',
    lineHeight: '24px',
  },
  FS20FW400LH24R: {
    fontFamily: 'SofiaSans-Regular',
    fontSize: '20px',
    fontWeight: '400',
    lineHeight: '24px',
  },
  FS20FW400LH34_3R: {
    fontFamily: 'SofiaSans-Regular',
    fontSize: '20px',
    fontWeight: '400',
    lineHeight: '34.3px',
  },
  FS20FW400LH29_8R: {
    fontFamily: 'SofiaSans-Regular',
    fontSize: '20px',
    fontWeight: '400',
    lineHeight: '29.8px',
  },
  FS18FW600LH29_8SB: {
    fontFamily: 'SofiaSans-SemiBold',
    fontSize: '18px',
    fontWeight: '400',
    lineHeight: '29.8px',
  },
  FS18FW600LH21_6SB: {
    fontFamily: 'SofiaSans-SemiBold',
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '21.6px',
  },
  time_buttons: {
    fontFamily: 'SofiaSans-SemiBold',
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '21.6px',
  },
  FS18FW500LH21_6M: {
    fontFamily: 'SofiaSans-Medium',
    fontSize: '18px',
    fontWeight: '500',
    lineHeight: '21.6px',
  },
  FS18FW500LH24_5M: {
    fontFamily: 'SofiaSans-Medium',
    fontSize: '18px',
    fontWeight: '500',
    lineHeight: '25.5px',
  },
  FS18FW400LH21_6R: {
    fontFamily: 'SofiaSans-Regular',
    fontSize: '18px',
    fontWeight: '400',
    lineHeight: '21.6px',
  },
  FS15FW600LH18SB: {
    fontFamily: 'SofiaSans-SemiBold',
    fontSize: '15px',
    fontWeight: '600',
    lineHeight: '18px',
  },
  FS16FW700LH19_2B: {
    fontFamily: 'SofiaSans-Bold',
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '19.2px',
  },
  FS16FW500LH19_2M: {
    fontFamily: 'SofiaSans-Medium',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '19.2px',
  },
  FS16FW400LH26_24R: {
    fontFamily: 'SofiaSans-Regular',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '26.24px',
  },
  FS16FW400LH19_2R: {
    fontFamily: 'SofiaSans-Regular',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '19.2px',
  },
  FS14FW600LH24_01R: {
    fontFamily: 'SofiaSans-SemiBold',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '24.01px',
  },
  FS14FW500LH24_5R: {
    fontFamily: 'SofiaSans-Medium',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '24.5px',
  },
  FS13FW400LH15_6R: {
    fontFamily: 'SofiaSans-Regular',
    fontSize: '13px',
    fontWeight: '400',
    lineHeight: '15.6px',
  },
};
